const listTypeEnum = {
  FAVOURITE: 'favourite',
  OKAUCHAN: 'okauchan',
  USER_LIST: 'userList',
};

export default listTypeEnum;
